module.exports = __webpack_public_path__ + "img/icon-delete.b2ac0aa4.svg";